import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-checkbox-input',
    standalone: false,
    templateUrl: './checkbox-input.component.html',
})
export class CheckboxInputComponent extends InputComponent {}
